import { render, staticRenderFns } from "./complianceList.vue?vue&type=template&id=5dddc51a&scoped=true&"
import script from "./complianceList.vue?vue&type=script&lang=js&"
export * from "./complianceList.vue?vue&type=script&lang=js&"
import style0 from "./complianceList.vue?vue&type=style&index=0&id=5dddc51a&prod&lang=scss&"
import style1 from "./complianceList.vue?vue&type=style&index=1&id=5dddc51a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dddc51a",
  null
  
)

export default component.exports